import React from 'react';
import './Modal.css'; // Reuse same modal styling

const ExtraMenuModal = ({ visible, onAction, onClose }) => {
  if (!visible) return null;

  const actions = ['View', 'Shuffle', 'Banish FD'];

  return (
    <div className="modal-backdrop">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h3>Extra Deck Options</h3>
        <ul className="action-list">
          {actions.map((action, index) => (
            <li key={index} onClick={() => onAction(action)}>{action}</li>
          ))}
        </ul>
        <button onClick={onClose}>Cancel</button>
      </div>
    </div>
  );
};

export default ExtraMenuModal;
